module.exports = __webpack_public_path__ + "assets/avatar_electric.50302129.svg";